import '../css/common.css';

const ChatBubble = ({ isResponse, text }) => {

    return (
        <div className={`${isResponse ? 'responseRow' : 'requestRow'}`}>
            <div className={`${isResponse ? 'response' : 'request'}`}>{text}</div>
        </div>
    );
};
export default ChatBubble;



